import { parseJson } from 'legacy/lut/classes/helpers/JsonHelper'
import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import { IELTFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getPrevEltVersion } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/versions/helpers/getPrevEltVersion'

import { IAddNewVersion } from '../ui/versions/addNewVersionDialog/models'

import { getBasicEltData } from './requestsHelpers/getBasicEltData'

export const getNewVersionData = async ({
  partnerGroupInfo,
  versionName,
  versionSerialNumber,
  partnerId,
  fYear,
  fQuarter,
  eltType,
}: IAddNewVersion) => {
  const prevVersion = partnerGroupInfo?.groupId
    ? await getPrevEltVersion({
        partnerId: null,
        eltType,
        groupId: partnerGroupInfo?.groupId || null,
      })
    : null

  const parsedLastFormData = prevVersion?.FormData
    ? parseJson<IELTFormData>(prevVersion?.FormData)
    : null

  const { item, formData, forceUpdateData } = await getBasicEltData({
    item: {
      EntryId: -1,
      VersionName: versionName,
      Version: versionSerialNumber,
      FYear: fYear,
      FQuarter: fQuarter,
      EltType: eltType,
    } as IELTData,

    partnerId,
    partnerGroupData: partnerGroupInfo,
    fYear,
    fQuarter,
    isRollup: parsedLastFormData?.IsRollup || 0,
  })

  return { item, formData, forceUpdateData }
}
